// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"256":"74d5c23b","340":"9544e220","392":"f30af7c9","453":"6d886622","560":"ecfa5a54","668":"7ffec299","673":"fe6b6aa2"}[chunkId] + ".chunk.js";
};